<template>
  <div v-if="show">
    <div v-if="!edit">
      Name: {{ guardian_data.name }}<br/>
      City: {{ guardian_data.city }}<br/>
      State: {{ guardian_data.state }}<br/>
    </div>
    <form @submit.prevent="createOrUpdate" v-if="edit">
      <div class="form-group">
        <input class="form-control" type="hidden" name="id" v-model="guardian_data.id">
        <div>
          <label class="form-label" for="name">Name</label>:
          <input class="form-control" type="text" name="name" id="name" v-model="guardian_data.name" required/>
        </div>

        <div>
          <label class="form-label" for="city">City</label>:
          <input class="form-control" type="text" name="city" id="city" v-model="guardian_data.city" required/>
        </div>

        <div>
              <label class="form-label" for="state">State</label>:
              <select class="form-control" name="state" id="state" v-model="guardian_data.state" required>
                <option value="AL">Alabama</option>
                <option value="AK">Alaska</option>
                <option value="AZ">Arizona</option>
                <option value="AR">Arkansas</option>
                <option value="CA">California</option>
                <option value="CO">Colorado</option>
                <option value="CT">Connecticut</option>
                <option value="DE">Delaware</option>
                <option value="DC">District Of Columbia</option>
                <option value="FL">Florida</option>
                <option value="GA">Georgia</option>
                <option value="HI">Hawaii</option>
                <option value="ID">Idaho</option>
                <option value="IL">Illinois</option>
                <option value="IN">Indiana</option>
                <option value="IA">Iowa</option>
                <option value="KS">Kansas</option>
                <option value="KY">Kentucky</option>
                <option value="LA">Louisiana</option>
                <option value="ME">Maine</option>
                <option value="MD">Maryland</option>
                <option value="MA">Massachusetts</option>
                <option value="MI">Michigan</option>
                <option value="MN">Minnesota</option>
                <option value="MS">Mississippi</option>
                <option value="MO">Missouri</option>
                <option value="MT">Montana</option>
                <option value="NE">Nebraska</option>
                <option value="NV">Nevada</option>
                <option value="NH">New Hampshire</option>
                <option value="NJ">New Jersey</option>
                <option value="NM">New Mexico</option>
                <option value="NY">New York</option>
                <option value="NC">North Carolina</option>
                <option value="ND">North Dakota</option>
                <option value="OH">Ohio</option>
                <option value="OK">Oklahoma</option>
                <option value="OR">Oregon</option>
                <option value="PA">Pennsylvania</option>
                <option value="RI">Rhode Island</option>
                <option value="SC">South Carolina</option>
                <option value="SD">South Dakota</option>
                <option value="TN">Tennessee</option>
                <option value="TX">Texas</option>
                <option value="UT">Utah</option>
                <option value="VT">Vermont</option>
                <option value="VA">Virginia</option>
                <option value="WA">Washington</option>
                <option value="WV">West Virginia</option>
                <option value="WI">Wisconsin</option>
                <option value="WY">Wyoming</option>
              </select>
            </div>

        <button class="btn btn-form better_font" type="submit">Save</button>
      </div>
    </form>
    <div v-if="!edit">
      <button class="btn btn-form better_font mr-1" @click.prevent="toggleEdit">Edit</button>
      <button class="btn btn-danger better_font" @click.prevent="deleteGuardian(guardian_data.id)">Delete</button>
    </div>
    <hr/>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  name: "guardian",
  props:{
    guardian_data: Object
  },
  data(){
    return{
      errors: [],
      show: true,
      edit: true
    }
  },
  mounted(){
    this.checkId()
  },
  methods:{
    checkId(){
      if(!this.guardian_data.id)
        this.edit = true
    },
    updateGuardian(data){
      axios.put(
        `${process.env.VUE_APP_ENDPOINT}/api/applicant/profile/guardians/` + data.guardian.id,
        data
      )
    },
    createGuardian(data){
      axios.post(
        `${process.env.VUE_APP_ENDPOINT}/api/applicant/profile/guardians/`,
        data
      )
    },
    deleteGuardian(guardian_id){
      if(guardian_id)
        axios.delete(`${process.env.VUE_APP_ENDPOINT}/api/applicant/profile/guardians/` + guardian_id)
      this.show = false
    },
    createOrUpdate(event){
      if(event.target[0].name == 'id' && event.target[0].value !== ''){
        this.updateGuardian(this.dataFormatter(event.target))
      }else{
        this.createGuardian(this.dataFormatter(event.target))
      }
      this.edit = false
    },
    dataFormatter(form_input_data){
      let ready = {guardian:{}}
      Array.from(form_input_data).forEach( el => {
        if(el.name)
          ready.guardian[el.name] = el.value
      })
      return ready
    },
    toggleEdit(){
      this.edit = !this.edit
    }
  }
}
</script>

<style scoped>

.form-label {
  font-family: 'Montserrat', sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
}

.btn-form {
  background-color: #27AAE1;
  color: white;
}

.btn-form:hover {
  background-color: #1B86B5;
}

</style>
